import { AppWebsiteVisits } from '../../../_dashboard/app';

const MembershipActiveChart = ({ metric }) => <AppWebsiteVisits />;

export default MembershipActiveChart;
